// source: starlord/messages/request/application_upsert_request.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var starlord_messages_models_application_details_pb = require('../../../starlord/messages/models/application_details_pb.js');
goog.object.extend(proto, starlord_messages_models_application_details_pb);
goog.exportSymbol('proto.ApplicationUpsertRequest', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ApplicationUpsertRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ApplicationUpsertRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ApplicationUpsertRequest.displayName = 'proto.ApplicationUpsertRequest';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ApplicationUpsertRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.ApplicationUpsertRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ApplicationUpsertRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ApplicationUpsertRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    applicationdetails: (f = msg.getApplicationdetails()) && starlord_messages_models_application_details_pb.ApplicationDetails.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ApplicationUpsertRequest}
 */
proto.ApplicationUpsertRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ApplicationUpsertRequest;
  return proto.ApplicationUpsertRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ApplicationUpsertRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ApplicationUpsertRequest}
 */
proto.ApplicationUpsertRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new starlord_messages_models_application_details_pb.ApplicationDetails;
      reader.readMessage(value,starlord_messages_models_application_details_pb.ApplicationDetails.deserializeBinaryFromReader);
      msg.setApplicationdetails(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ApplicationUpsertRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ApplicationUpsertRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ApplicationUpsertRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ApplicationUpsertRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getApplicationdetails();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      starlord_messages_models_application_details_pb.ApplicationDetails.serializeBinaryToWriter
    );
  }
};


/**
 * optional ApplicationDetails applicationDetails = 1;
 * @return {?proto.ApplicationDetails}
 */
proto.ApplicationUpsertRequest.prototype.getApplicationdetails = function() {
  return /** @type{?proto.ApplicationDetails} */ (
    jspb.Message.getWrapperField(this, starlord_messages_models_application_details_pb.ApplicationDetails, 1));
};


/**
 * @param {?proto.ApplicationDetails|undefined} value
 * @return {!proto.ApplicationUpsertRequest} returns this
*/
proto.ApplicationUpsertRequest.prototype.setApplicationdetails = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ApplicationUpsertRequest} returns this
 */
proto.ApplicationUpsertRequest.prototype.clearApplicationdetails = function() {
  return this.setApplicationdetails(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ApplicationUpsertRequest.prototype.hasApplicationdetails = function() {
  return jspb.Message.getField(this, 1) != null;
};


goog.object.extend(exports, proto);
